<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">仪器设备清还</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请人">
          <el-input v-model="formInline.username" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择状态">
            <el-option v-for="item in $store.state.borrowStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room_id" clearable filterable :placeholder="`请选择`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table ref="table" :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="serial_no" fixed label="设备编号" width="120">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed  label="设备名称" min-width="160px">
        </custom-table-column>
        <custom-table-column label="状态"  prop="borrow_status_desc" width="100"  >
        </custom-table-column>
        <custom-table-column prop="start_time" label="设备借用时间" width="160">
        </custom-table-column>
        <custom-table-column prop="end_time" label="预计归还时间" width="160">
        </custom-table-column>
        <custom-table-column prop="username" label="申请人" width="100">
        </custom-table-column>
        <custom-table-column prop="apply_no" label="工号" width="100">
          <template slot-scope="scope" v-if="scope.row.borrow">
            <span>{{ scope.row.borrow.apply_no }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="apply_structure_1" label="所属组织结构" width="180">
          <template slot-scope="scope" v-if="scope.row.borrow">
            <span>{{ scope.row.borrow.apply_structure_1 }}{{ scope.row.borrow.apply_structure_2 }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="training_room_name" :label="`所属${$store.state.themeTitle}室`" width="160">
        </custom-table-column>
        <custom-table-column prop="usage" label="用途" width="160">
        </custom-table-column>
        <custom-table-column prop="device_model" label="型号" width="160">
        </custom-table-column>
        <custom-table-column prop="specification" label="规格" width="160">
        </custom-table-column>
        <custom-table-column prop="end_time" label="申请时间" width="160">
          <template slot-scope="scope" v-if="scope.row.borrow">
            <span>{{ scope.row.borrow.created_at }}</span>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status != 2" @click="handleOper(scope.row)" type="text"
              size="small">清还</el-button>
            <el-button @click="handlePrintRow(scope.row)" type="text" size="small">打印</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="清还" :visible.sync="centerDialogVisible" width="410px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="归还时间" prop="actual_return_time">
          <el-date-picker type="datetime" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择"
            v-model="ruleForm.actual_return_time" style="width:236px;"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <div style="display: none;">
      <Printt id="printArea" ref="printt" :printData="printData" ></Printt>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinPrint } from '@/assets/js/mixin/print';

export default {
  name: 'equipmentInto',
  mixins: [mixinList,mixinPrint],
  data() {
    return {
      formInline: {
        status: '',
        device_name: '',
        training_room_id: '',
        username: ''
      },
      ruleForm: {
        id:'',
        actual_return_time: '',
        // status:2,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      rules: {
        actual_return_time: [{ required: true, message: '请选择', trigger: 'change' }],
      }
    };
  },
  components: {},
  created() { },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    this.$store.dispatch('getTarinMent');
  },
  methods: {
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_device/borrow/individualList', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleOper(row) {
      this.ruleForm.id = row.id;
      this.ruleForm.actual_return_time = ''
      this.centerDialogVisible = true;
    },
    async setStatus() {
      let res = await this.$api.instance.interfaceServer(`api/new_device/borrow/return/${this.ruleForm.id}`, 'post', this.ruleForm);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '清还成功！',
        });
        this.centerDialogVisible = false
        this.handleQuery();
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
